import React, { isValidElement, useContext, useEffect, useState } from "react";
import { Context } from "../Context/Context";
import "./Register.css";
import { useNavigate } from "react-router-dom";
function Register(props) {
  const [currentEmail, setCurrentEmail] = useState("");
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const context = useContext(Context);
  const navigate = useNavigate();

  //current password letter collector
  function currentPasswordHandler(e) {
    setCurrentPassword(e.target.value);
  }
  // visible of login
  function visibleHandler(e) {
    props.setFormVisible(!props.formVisible);
  }

  // current letters in email collector
  function currentEmailHandle(e) {
    setCurrentEmail(e.target.value);
  }
  // submit function
  function submitHandler(e) {
    if (JSON.parse(localStorage.getItem(currentEmail)) === null) {
      alert("Email is incorrect please enter valid email adress");
      return;
    } else if (
      currentEmail !== JSON.parse(localStorage.getItem(currentEmail)).email
    ) {
      alert("Email is incorrect please enter valid email adress");
      return;
    } else if (
      currentPassword !==
      JSON.parse(localStorage.getItem(currentEmail)).password
    ) {
      alert("password is incorrect please enter valid password");
      return;
    }

    localStorage.setItem(
      "userName",
      JSON.parse(localStorage.getItem(currentEmail)).userName
    );

    setCurrentEmail("");
    setCurrentPassword("");
    navigate("home");
  }
  //navigation function
  function navigateHandler() {
    navigate("register");
  }
  // logout function
  function logOutHandler() {
    context.setIsLogged(false);
    localStorage.setItem("isLogged", false);
  }
  // logOut from account

  useEffect(() => {
    if (localStorage.getItem("isLogged") !== null) {
      context.setIsLogged(JSON.parse(localStorage.getItem("isLogged")));
    }
  }, []);

  //login into account
  function loginHandler() {
    if (
      JSON.parse(localStorage.getItem(currentEmail)) !== null &&
      currentEmail === JSON.parse(localStorage.getItem(currentEmail)).email &&
      currentPassword ===
        JSON.parse(localStorage.getItem(currentEmail)).password
    ) {
      context.setIsLogged(true);
      localStorage.setItem("isLogged", true);
    }
  }

  return (
    <div className="register-outer-div">
      {props.formVisible && (
        <form className="register-login-form">
          <div className="email-outer-div">
            <label htmlFor="email">Email:</label>
            <input
              onChange={currentEmailHandle}
              id="email"
              type="email"
              required
            ></input>
          </div>
          <div className="password-outer-div">
            <label htmlFor="password">Password:</label>
            <input
              id="password"
              type="password"
              required
              onChange={currentPasswordHandler}
            ></input>
          </div>
          <button
            className="login-button"
            type="submit"
            onClick={(e) => {
              submitHandler(e);
              loginHandler();
            }}
          >
            Submit
          </button>
        </form>
      )}
      {!context.isLogged ? (
        <>
          <button
            id="login"
            className="register-buttons"
            onClick={() => {
              visibleHandler();
            }}
          >
            Login
          </button>
          <button className="register-buttons" onClick={navigateHandler}>
            Sign Up
          </button>
        </>
      ) : (
        <div className="welcome-username-outer-div">
          {email !== null && (
            <p className="welcome-username">
              Welcome:{localStorage.getItem("userName")}
            </p>
          )}

          <button className="log-out" onClick={logOutHandler}>
            LogOut
          </button>
        </div>
      )}
    </div>
  );
}

export default Register;
